import { useContext } from 'react';
import { Link } from 'react-router-dom';
import SidebarContext from '../../../../contexts/sidebar';
import { translate } from '../../../../utils/Common';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

// Home del rol mostrador: dos acciones, nada más.
const CounterHome = () => {
    const sidebarContext = useContext(SidebarContext);

    return (
        <div className="flex min-h-[calc(100vh-220px)] items-center justify-center p-4">
            <Card className="flex flex-col gap-6 p-6">
                <Button asChild size="lg" className="h-28 w-40 rounded-2xl text-lg">
                    <Link
                        to="/dashboard/packages/dropoff"
                        onClick={() => sidebarContext.handleChangeCurrentPage('Recibir Paquete')}
                    >
                        {translate("dashboard.home.counter_home.receive")}
                    </Link>
                </Button>

                <Button asChild variant="secondary" size="lg" className="h-28 w-40 rounded-2xl text-lg">
                    <Link
                        to="/dashboard/packages/pickup"
                        onClick={() => sidebarContext.handleChangeCurrentPage('Entregar Paquete')}
                    >
                        {translate("dashboard.home.counter_home.deliver")}
                    </Link>
                </Button>
            </Card>
        </div>
    );
}

export default CounterHome;
